import script from "./HeaderContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderContent.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderContent.vue?vue&type=style&index=0&id=2bd29964&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd29964"]])

export default __exports__